import { motion } from 'framer-motion';
import Button from '../Button/Button';
import { trackButtonClick } from '../../../utils/analytics';
import './ProductCard.css';

export interface Product {
  id: string;
  name: string;
  price: string;
  description: string;
  features: string[];
  inStock: boolean;
  badge?: string;
}

interface ProductCardProps {
  product: Product;
  onNotifyClick: () => void;
  variant?: 'wholesale' | 'ceramic' | 'pets';
  inView?: boolean;
}

const ProductCard: React.FC<ProductCardProps> = ({
  product,
  onNotifyClick,
  variant = 'wholesale',
  inView = true,
}) => {
  const handleBuyClick = () => {
    trackButtonClick('Buy Now', 'product-card', {
      product_id: product.id,
      product_name: product.name,
      in_stock: product.inStock,
    });
    onNotifyClick();
  };

  return (
    <motion.div
      className={`product-card product-card--${variant}`}
      initial={{ opacity: 0, y: 30 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6 }}
    >
      {product.badge && (
        <div className="product-card__badge product-card__badge--special">
          {product.badge}
        </div>
      )}

      <h3 className="product-card__name">{product.name}</h3>
      <p className="product-card__price">{product.price}</p>
      <p className="product-card__description">{product.description}</p>

      <ul className="product-card__features">
        {product.features.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </ul>

      <Button
        variant="primary"
        onClick={handleBuyClick}
        className="product-card__button"
      >
        Buy Now
      </Button>
    </motion.div>
  );
};

export default ProductCard;
